import React from "react";
import styled from "styled-components/macro";

export const GrayBox = styled.div`
  background: #eee;
  padding: 10px;
  box-shadow: 0 0 3px #989898;
  border-radius: 5px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
const InfoBox = styled(GrayBox)`
  & h1 {
    margin: 0 0 10px;
    line-height: 40px;
    text-align: center;
    color: #6b6b6b;
  }
  & > span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-weight: 500;
    color: #004a95;
  }
  & .importStatus {
    color: ${props => (props.status ? "var(--color2)" : "var(--failed)")};
  }
`;
export const InfoSection = ({ name, userId, status }) => (
  <InfoBox status={status}>
    <h1>{name}</h1>
    <span>کد پرسنلی : {userId}</span>
    <span>
      شماره گیری :{" "}
      <span className="importStatus">{status ? "فعال" : "غیرفعال"}</span>
    </span>
  </InfoBox>
);
const ListItemSectionStyle = styled(GrayBox)`
  & i {
    float: right;
    font-size: 25px;
    margin-left: 15px;
    color: ${({ iconColor }) => iconColor};
  }
  & span {
    font-size: 15px;
  }
`;
export const ListItemSection = ({ title, icon, click }) => (
  <ListItemSectionStyle iconColor={icon.color} onClick={click}>
    <i className={icon.icon}></i>
    <span>{title}</span>
  </ListItemSectionStyle>
);
